export default "__VITE_ASSET__BYfn7TKG__"